// extracted by mini-css-extract-plugin
export default {"pageContent":"AdminContentPage_pageContent__QMOW-"};